module.exports = __webpack_public_path__ + "img/contact-logo.a8ef05d6.png";